import AdminModule from '@/modules/admin';
import {ProfilePageLoad} from '@/modules/admin/pages';
import ContractRequestModule from '@/modules/contractRequest';
import {ClientCodesPagePageLoad} from '@/modules/contractRequest/pages';
import FaqsModule from '@/modules/faqs';
import NomenclatorsModule from '@/modules/nomenclators';
import PaymentsModule from '@/modules/payments';
import HomePageGate from '@/modules/home/HomePageGate';

export default {
  Home: {
    exact: true,
    path: ['/'],
    component: HomePageGate,
  },
  Profile: {
    exact: true,
    path: ['/profile', '/profile/:tab'],
    permissions: [],
    component: ProfilePageLoad,
  },
  ClientCodes: {
    exact: true,
    path: '/clientCodes',
    component: ClientCodesPagePageLoad,
  },
  Payments: {
    exact: false,
    path: '/payments',
    component: PaymentsModule,
  },
  ContractRequest: {
    exact: false,
    path: '/contractrequest',
    component: ContractRequestModule,
  },
  Faqs: {
    exact: false,
    path: '/faqs',
    component: FaqsModule,
  },
  Nomenclators: {
    exact: false,
    path: '/nomenclators',
    component: NomenclatorsModule,
  },
  User: {
    exact: false,
    path: '/admin',
    component: AdminModule,
  },
};
